module.exports = __webpack_public_path__ + "img/V-L-246-unload-standup-base.c3bd3727.png";